import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "product_main"
};
const _hoisted_2 = {
  key: 0,
  class: "status"
};
const _hoisted_3 = {
  key: 1,
  class: "status"
};
const _hoisted_4 = {
  key: 2,
  class: "product_container"
};
const _hoisted_5 = {
  class: "contain"
};
const _hoisted_6 = ["onLoad", "onError", "onClick", "src", "alt"];
const _hoisted_7 = {
  class: "el-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Homehead = _resolveComponent("Homehead");
  const _component_el_text = _resolveComponent("el-text");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Homehead, {
    index: 1
  }), _createElementVNode("div", _hoisted_1, [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.loadingText), 1)) : $data.error ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($data.error), 1), _createElementVNode("button", {
    class: "retry",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.loadProducts && $options.loadProducts(...args))
  }, _toDisplayString($options.retryText), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.productlist, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: item.slug || index
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      onLoad: $event => $options.imgLoaded(index),
      onError: $event => $options.onImageError(index),
      onClick: $event => $options.onProductClick(item.slug),
      src: item.coverImage || $data.placeholderImage,
      alt: $options.getName(item)
    }, null, 40, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_text, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getName(item)), 1)]),
      _: 2
    }, 1024)])])]);
  }), 128))]))])]);
}